module.exports = {
      id: "icon-ApartmentLiving-usage",
      viewBox: "0 0 26 26",
      url: "/img/" + "063d56c0a9dcab4c3026b31719d540d0.svg#icon-ApartmentLiving",
      toString: function () {
        return this.url;
      }
    }